export default __webpack_public_path__ + "static/media/zendesk.2a0028eb.svg";